export default __webpack_public_path__ + "static/media/juvenile_jade.22506f5d.png";